import { render } from "./SuEditForm.vue?vue&type=template&id=6213a526"
import script from "./SuEditForm.vue?vue&type=script&lang=js"
export * from "./SuEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__